<template>
  <div id="chronic-container">
    <header class="sac__font-16 bold n60">
      Muted Chronic Alerts | Total: {{ chronicAlerts.length }}
    </header>
    <div class="margin-top-16">
      <div
        v-for="(c, idx) in chronicAlerts"
        :key="idx"
        class="grid-column ai-c jc-s gap-16 margin-top-4"
      >
        <div class="sac__font-14 semi-bold">
          {{ c.alertType }}
        </div>
        <div class="sac__font-12 n50">
          Muted on: {{ formattedDate(c.creationDate) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemHealthMixin from '@shared/mixins/systemHealthMixin';

export default {
  name: 'ChronicDetail',
  mixins: [systemHealthMixin],
};
</script>
<style lang="scss">

#chronic-container {
  background-color: $WHITE;
  width: 100%;
  padding: 1rem;
  max-height: 350px;
  box-shadow: 0 1px 10px 0 rgba(9, 15, 32, 0.1);
  border-radius: 4px;
}
</style>
